import { addToListModalStyles } from "@dana/Overrides/Components/AddToListModal";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

addToListModalStyles.modal = mergeToNew(addToListModalStyles.modal, {
    size: 500,
    cssOverrides: {
        modalTitle: css`
            border: none;
            position: relative;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 16px;
                        `,
                        css`
                            padding: 16px;
                        `,
                        css`
                            padding: 40px 40px 24px;
                        `,
                        css`
                            padding: 40px 40px 24px;
                        `,
                    ],
                    "min",
                )}
        `,
        modalContent: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 16px;
                        `,
                        css`
                            padding: 16px;
                        `,
                        css`
                            padding: 0 40px 40px;
                        `,
                        css`
                            padding: 0 40px 40px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
});

addToListModalStyles.scheduleReminderModal = mergeToNew(addToListModalStyles.scheduleReminderModal, {
    modal: {
        sizeVariant: "large",
        size: 850,
    },
});
